import React from 'react';
import { Box, Select, MenuItem, FormControl, InputLabel, OutlinedInput, Chip } from '@mui/material';

const FilterToolbar = ({ uniqueTags, uniqueCategories, selectedTags, selectedCategories, handleTagChange, handleCategoryChange }) => {
  const handleDeleteCategory = (categoryToRemove) => {
    const newValue = selectedCategories.filter((c) => c !== categoryToRemove);
    handleCategoryChange({ target: { value: newValue } });
  };

  const handleDeleteTag = (tagToRemove) => {
    const newValue = selectedTags.filter((t) => t !== tagToRemove);
    handleTagChange({ target: { value: newValue } });
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 250,
        borderRadius: '12px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
      },
    },
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: '1rem', padding: '1rem' }}>
      <FormControl variant="outlined" sx={{ minWidth: 200 }}>
        <InputLabel>Categories</InputLabel>
        <Select
          multiple
          value={selectedCategories}
          onChange={handleCategoryChange}
          input={<OutlinedInput label="Categories" />}
          MenuProps={MenuProps}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip 
                  key={value} 
                  label={value} 
                  onDelete={() => handleDeleteCategory(value)}
                  onMouseDown={(event) => {
                    event.stopPropagation();
                  }}
                  sx={{
                    borderRadius: '8px',
                    backgroundColor: 'rgba(29, 64, 137, 0.1)',
                    color: '#1d4089',
                    '& .MuiChip-deleteIcon': {
                        color: '#1d4089',
                    }
                  }}
                />
              ))}
            </Box>
          )}
        >
          {uniqueCategories.map(category => (
            <MenuItem key={category} value={category}>
              {category}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{ minWidth: 150 }}>
        <InputLabel>Tags</InputLabel>
        <Select
          multiple
          value={selectedTags}
          onChange={handleTagChange}
          input={<OutlinedInput label="Tags" />}
          MenuProps={MenuProps}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip 
                  key={value} 
                  label={value} 
                  onDelete={() => handleDeleteTag(value)}
                  onMouseDown={(event) => {
                    event.stopPropagation();
                  }}
                  sx={{
                    borderRadius: '8px',
                    backgroundColor: 'rgba(231, 154, 43, 0.1)',
                    color: '#E79A2B',
                    '& .MuiChip-deleteIcon': {
                        color: '#E79A2B',
                    }
                  }}
                />
              ))}
            </Box>
          )}
        >
          {uniqueTags.map(tag => (
            <MenuItem key={tag} value={tag}>
              {tag}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default FilterToolbar;
